<style>
</style>
<template>
  <div id="root-inner" :class="[browser, navigationClass]">
    <transition name="fade" appear>
      <navigation v-if="navigationEnabled"></navigation>
    </transition>
    <transition :name="transitionName" appear>
      <router-view></router-view>
    </transition>
    <payment-modal @close="togglePaymentModal" v-if="paymentModalOpen"></payment-modal>
  </div>
</template>
<script>
import platform     from 'platform';
import {mapGetters, mapMutations} from 'vuex';

import Navigation from './navigation.vue';
import PaymentModal from './payment-modal.vue';

const backwardMappings = {
  'pool':                   'dashboard',
  'newPool':                'dashboard',
  'poolArchives':           'dashboard',
  'faq':                    'dashboard',
  'account':                'dashboard',
  'contact':                'dashboard',
  'dashboard':              'login',
  'login':                  'welcome',
  'confirmUser':            'welcome',
  'passwordReset':          'welcome',
  'resendUserConfirmation': 'confirmUser'
};

export default {
  name: 'MainView',
  components: {
    Navigation,
    PaymentModal
  },
  data: () => {
    return {
      transitionName: 'slide-forward',
      browser: platform.name.toLowerCase()
    };
  },
  computed: {
    ...mapGetters('paymentModal', ['paymentModalOpen']),
    navigationEnabled: function() {
      return this.$store.state.navigation.enabled;
    },
    navigationClass: function() {
      return this.navigationEnabled ? 'navigation' : '';
    }
  },
  methods: {
    ...mapMutations('paymentModal', {togglePaymentModal: 'toggle'})
  },
  watch: {
    '$route': function(to, from) {
      if (backwardMappings[from.name] === to.name) {
        this.transitionName = 'slide-backward';
      } else {
        this.transitionName = 'slide-forward';
      }
    }
  }
};
</script>
